// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2d4eN","right":"Footer_right__3s9Ax","buttons":"Footer_buttons__hTVqB"};